<template>
  <div ref="linkInBioContainer" v-resize="getLinkInBioWidth">
    <v-card
      :class="[{ 'rounded-corners': !isWebPage }, 'mb-3 overflow-y-auto  overflow-x-hidden']"
      :height="height"
      :max-height="maxHeight"
    >
      <v-card-text class="ma-0 pa-0 white pb-4">
        <div ref="businessCard">
          <BusinessCardRotator
            :cardCorners="businessProfile.card_corners"
            :logoFrame="businessProfile.logo_frame"
            :logoImageURL="businessProfile.logo_image_url"
            :reverseImageURL="linkInBio.reverseImageURL"
            :backgroundImageURL="linkInBio.backgroundImageURL"
            :showBackgroundElevation="false"
            :hideToggleControl="true"
            :businessCardSideProp="1"
            :reverseCardLink="linkInBio.cardBackUrl"
          />
        </div>
        <v-row no-gutters :style="`padding: ${x * 0.04762}px;`">
          <!--Start: Avatar & company info-->
          <v-col cols="12">
            <v-list-item class="pa-0">
              <v-list-item-avatar v-if="linkInBio.displayImageURL != ''" size="38" style="margin-right:8px;">
                <v-img :src="linkInBio.displayImageURL" height="38" dark></v-img>
              </v-list-item-avatar>
              <v-list-item-avatar v-else color="rgba( 241, 95, 49, 0.24)" size="38" style="margin-right:8px;">
                <v-icon dark size="25">work</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <div class="font-weight-medium" :style="`font-size: 12px; line-height: 1.2;`">
                  {{ linkInBio.businessName }}
                </div>
                <div :style="`font-size: 10px; line-height: 1.2;`" class="text--disabled">
                  {{ getBusinessCityAndCountry() }}
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <!--End: Avatar & company info-->

          <!--Start: Social icons--->
          <v-col cols="12" class="d-flex flex-wrap justify-center">
            <template v-for="(item, index) in contactAndSocialIcons">
              <a
                v-if="item.hasInfo && item.type == 'tel'"
                :href="`tel:${item.info}`"
                class="text-decoration-none ma-2"
                :key="`contactSocial${index}`"
              >
                <v-avatar color="grey lighten-4" size="30">
                  <v-img height="12" contain :src="item.icon"></v-img>
                </v-avatar>
              </a>
              <a
                v-if="item.hasInfo && item.type == 'email'"
                :href="`mailto:${item.info}`"
                class="text-decoration-none ma-2"
                :key="`contactSocial${index}`"
              >
                <v-avatar color="grey lighten-4" size="30">
                  <v-img height="12" contain :src="item.icon"></v-img>
                </v-avatar>
              </a>
              <a
                v-if="item.hasInfo && item.type != 'tel' && item.type != 'email'"
                :href="`${item.urlPrefix}${item.info}`"
                target="_blank"
                class="text-decoration-none ma-2"
                :key="`contactSocial${index}`"
              >
                <v-avatar color="grey lighten-4" size="30">
                  <v-img height="12" contain :src="item.icon"></v-img>
                </v-avatar>
              </a>
            </template>
          </v-col>
          <!--End: Social icons--->

          <v-col cols="12">
            <div class="d-flex justify-space-between flex-wrap">
              <template v-for="(link, index) in linkInBio.links">
                <!--Start: Heading--->
                <div
                  v-if="link.type == 'heading' && !link.isHidden"
                  class="d-block"
                  style="width:100%;"
                  dense
                  :key="`heading${index}`"
                  :ref="`link${index}`"
                >
                  <div
                    class="text-left font-weight-medium  black--text"
                    :style="`font-size: 12px; line-height: 1.2; margin-top:${x * 0.1}px; margin-bottom: ${x * 0.02}px`"
                  >
                    {{ link.heading }}
                  </div>
                </div>
                <!--End: Heading--->

                <!--Start: Links and thumbnail--->
                <div
                  style="width:48%;"
                  v-if="link.type == 'link' && !link.isHidden"
                  :key="`heading${index}`"
                  class="mb-4"
                  :ref="`link${index}`"
                >
                  <!-- <a :href="link.url" class="text-decoration-none" target="_blank"> -->
                  <v-card
                    elevation="3"
                    rounded="lg"
                    :key="`link${link}`"
                    :style="`margin-top:${x * 0.05}px; `"
                    class="align-start pa-0"
                    height="100%"
                    @click="redirectToURL(link.url)"
                  >
                    <img
                      :aspect-ratio="378 / 250"
                      width="100%"
                      class="rounded-t-lg"
                      :src="
                        link.thumbnailUrl != '' && link.hasThumbnail
                          ? link.thumbnailUrl
                          : require('@/assets/link-preview-placeholder-image.png')
                      "
                      style="object-fit: cover; aspect-ratio: 378 / 250;"
                    />
                    <p class="black--text px-1 text-wrap mb-0" style="font-size: 9.5px;line-height: 16px">
                      {{ link.title == "" ? "Untitled Link" : link.title }}
                    </p>
                  </v-card>
                  <!-- </a> -->
                </div>
                <!-- End: Links and thumbnail -->
              </template>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BusinessCardRotator from "@/components/BusinessCardRotator";
import { mapGetters } from "vuex";

export default {
  components: {
    BusinessCardRotator,
  },
  data() {
    return {
      x: 0,
    };
  },
  updated() {
    this.$nextTick(function() {
      //Get the focused input field from AddEditLinks
      this.$root.$on("linkFocused", (index) => {
        if (index == 0) this.$refs[`businessCard`].scrollIntoView({ behavior: "smooth" });
        else this.$refs[`link${index}`][0].scrollIntoView({ behavior: "smooth" });
      });
    });
  },

  props: {
    linkInBio: { type: Object },
    height: { type: String },
    maxHeight: { type: String },
    isWebPage: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(["businessProfile"]),
    contactAndSocialIcons() {
      return [
        {
          hasInfo: this.linkInBio.hasPappyonCardLink,
          info: this.linkInBio.pappyonCardLink,
          icon: require("@/assets/pappyon-icon.png"),
          type: "",
          urlPrefix: "https://",
        },
        {
          hasInfo: this.linkInBio.hasPhoneNumber,
          info: this.linkInBio.phoneNumber,
          icon: require("@/assets/call-icon.svg"),
          type: "tel",
        },
        {
          hasInfo: this.linkInBio.hasEmail,
          info: this.linkInBio.email,
          icon: require("@/assets/email-icon.png"),
          type: "email",
        },
        {
          hasInfo: this.linkInBio.hasWebsite,
          info: this.linkInBio.website,
          icon: require("@/assets/website-icon.svg"),
          type: "",
          urlPrefix: "https://",
        },
        {
          hasInfo: this.linkInBio.hasFacebook,
          info: this.linkInBio.facebook,
          icon: require("@/assets/facebook-icon.svg"),
          type: "",
          urlPrefix: "https://www.facebook.com/",
        },
        {
          hasInfo: this.linkInBio.hasInstagram,
          info: this.linkInBio.instagram,
          icon: require("@/assets/instagram-icon.svg"),
          type: "",
          urlPrefix: "https://www.instagram.com/",
        },
        {
          hasInfo: this.linkInBio.hasLinkedIn,
          info: this.linkInBio.linkedIn,
          icon: require("@/assets/linkedin-icon.svg"),
          type: "",
          urlPrefix: "https://www.linkedin.com/",
        },
        {
          hasInfo: this.linkInBio.hasTwitter,
          info: this.linkInBio.twitter,
          icon: require("@/assets/twitter-icon.svg"),
          type: "",
          urlPrefix: "https://twitter.com/",
        },
        {
          hasInfo: this.linkInBio.hasYoutube,
          info: this.linkInBio.youtube,
          icon: require("@/assets/youtube-icon.svg"),
          type: "",
          urlPrefix: "https://www.youtube.com/",
        },
        {
          hasInfo: this.linkInBio.hasPodcast,
          info: this.linkInBio.podcast,
          icon: require("@/assets/podcast-icon.svg"),
          type: "",
          urlPrefix: "https://",
        },
      ];
    },
  },
  methods: {
    getBusinessCityAndCountry() {
      if (this.linkInBio.city != "" && this.linkInBio.country != "")
        return this.linkInBio.city + ", " + this.linkInBio.country;
      else return this.linkInBio.city != "" ? this.linkInBio.city : this.linkInBio.country;
    },
    getLinkInBioWidth() {
      if (this.$refs.linkInBioContainer != null) this.x = this.$refs.linkInBioContainer.clientWidth;
    },
    redirectToURL(url) {
      if (url.indexOf("http://") != 0 && url.indexOf("https://") != 0) url = "http://" + url;

      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.rounded-corners {
  border-radius: 20px !important;
}
</style>
